import React, { useEffect, useState } from 'react';
import { Control, Controller, useWatch } from 'react-hook-form';
import { TextField, MenuItem, CircularProgress, Box, Stack, Typography, Switch, styled, Grid } from '@mui/material';
import { RegulationFormValues } from '../DataTable/dataTypes';

interface RegulationFieldsProps {
  control: Control<RegulationFormValues>;
  disabled?: boolean;
}

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#19857b',
        ...theme.applyStyles('dark', {
          backgroundColor: '#177ddc',
        }),
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
    ...theme.applyStyles('dark', {
      backgroundColor: 'rgba(255,255,255,.35)',
    }),
  },
}));

const ValidityFields: React.FC<RegulationFieldsProps> = ({
  control,
  disabled,
}) => {

  const validity = useWatch({ control, name: 'validity' });
  const code = useWatch({ control, name: 'code' });

  return (
    code !== '' ?

    <Grid container justifyContent={'space-between'} spacing={1}>

    <Grid item md={3}>

      <Stack direction="row" spacing={1}
        sx={{
          alignItems: 'center'
          // , position: 'absolute', top: '26px', right: '80px' 
        }}
      >
        <Typography>Vigente</Typography>

        <Controller
          // name={`tasks.${index}.confidential`}
          name={'validity'}
          control={control}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <AntSwitch
              checked={value}
              onChange={onChange}
              disabled={disabled}
            />
          )}
        />
      </Stack>

    </Grid>

    <Grid item md={2}>

      {!validity &&

        <Controller
          name={`expirationDate`}
          control={control}
          // rules={{ required: 'El primer plazo es obligatorio' }}
          render={({ field: { onChange, value }, fieldState: { error } }) => {
            const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
              const localDate = new Date(e.target.value);
              localDate.setHours(localDate.getHours() + 10);
              onChange(localDate.toISOString());
            };

            const displayValue = value ? value.toString().split('T')[0] : '';

            return (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginBottom: '10px',
                }}
              >
                <TextField
                  label="No vigente desde"
                  type="date"
                  value={displayValue}
                  // InputProps={{ inputProps: { min: minimumEntryDate() } }}
                  onChange={handleDateChange}
                  sx={{
                    borderRadius: '5px',
                    ...(error && { border: '1px solid red !important' }),
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '5px',
                      ...(error && {
                        borderColor: 'red',
                      }),
                      '&.Mui-focused fieldset': {
                        borderColor: error ? 'red' : 'primary.main',
                      },
                    },
                    '& .MuiInputLabel-root': {
                      color: error ? 'red' : 'inherit',
                    },
                    '& .MuiFormHelperText-root': {
                      color: 'red',
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={disabled}
                />
                {error && (
                  <span
                    style={{
                      color: 'red',
                      fontSize: '12px',
                      marginTop: '3px',
                      marginLeft: '10px',
                    }}
                  >
                    {error.message}
                  </span>
                )}
              </div>
            );
          }}
        />

      }

    </Grid>

    <Grid item md={7}>

      {!validity &&

        <Controller
          name={`expirationReason`}
          control={control}
          // rules={{ required: 'Descripción de la tarea es obligatorio' }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              label="Motivo"
              error={!!error}
              helperText={error ? error.message : null}
              fullWidth
              disabled={disabled} // Deshabilitar en modo solo lectura
            />
          )}
        />

      }

    </Grid >





  </Grid>

      :

<></>



  )
}

export default ValidityFields;